const AccessMatrix = {
    "/manager-ug": ["Manager_UG"],
    "/manager-int": ["Manager_INT"],
    "/contrat/consulter-contrat/all": ["Controle"],
    "/contrat/consulter-contrat/ug": ["Controle_UG"],
    "/contrat/consulter-contrat/int": ["Createur"],
    "/contrat/rechercher-contrat": ["Createur"],
    "/admin/creer-ug": ["Admin"],
    "/admin/modifier-ug": ["Admin"],
    "/admin/creer-int": ["Admin"],
    "/admin/modifier-int": ["Admin"],
    "/admin/creer-utilisateur": ["Admin"],
    "/admin/modifier-utilisateur": ["Admin"],
    "/contrat/ajouter-contrat": ["Createur"],
    "/contrat/estimer-contrat": ["Createur"]
};

export default AccessMatrix;